/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module GraphicssettingTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface GraphicsSettingPlugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GPUInfo".
 */
export interface GPUInfo {
    GPU: {
        LongGPUName: string;
        ShortGPUName: string;
        ActualVRAMSize: string;
        GPURAMType: string;
        IsQuadro: string;
        DeviceId: string;
        VendorId: string;
        SubSystemId: string;
        SubVendorId: string;
        GPUArchitecture: string;
        GPUArchImplementation?: string;
        IsPrimary: string;
        TensorCores?: string;
        GpuHandle: string;
        SKUMod?: string;
        Tgp: string;
    }[];
    SLI: SLI;
    IsOptimus: string;
}
export interface SLI {
    SLISupported: string;
    HasActiveSLITopology: string;
    ActiveTopologyGPUCount: string;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GenericInfo".
 */
export interface GenericInfo {
    PhysicalMemoryCapacity: string;
    TotalPhysicalMemory: string;
    CurrentResolution: string;
    DriverVersion: string;
    DriverType?: DriverTypeEnum;
    IsDCHDriverInstalled: string;
    MoboType: string;
    MinimumDriverVersion: string;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "LanguagePreference".
 */
export interface LanguagePreference {
    languageCode?: string;
    isSaved?: boolean;
}
/**
 * NIS2 Resolution
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "NIS2Resolution".
 */
export interface NIS2Resolution {
    [k: string]: any;
}
/**
 * NGXOverrideFeedback
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "NGXOverrideFeedback".
 */
export interface NGXOverrideFeedback {
    [k: string]: any;
}
/**
 * NGXOverrideConstraints
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "NGXOverrideConstraints".
 */
export interface NGXOverrideConstraints {
    [k: string]: any;
}
/**
 * feedback bits for SR and RR
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "NGXOverrideSR_RR_Feedback".
 */
export interface NGXOverrideSR_RR_Feedback {
    [k: string]: any;
}
/**
 * error feedback bits for override features
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "NGXOverrideErrFeedback".
 */
export interface NGXOverrideErrFeedback {
    [k: string]: any;
}
/**
 * Gpu status at app launch for FGX
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "FgxAppLaunchedGpuState".
 */
export interface FgxAppLaunchedGpuState {
    [k: string]: any;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIDVCSupportReturn".
 */
export interface GetAIDVCSupportReturn {
    /**
     * RTX DVC is supported or not
     */
    isSupported?: boolean;
    /**
     * Error code for PPE features like NIS2, DeepDVC, TrueHDR
     */
    errorCode?: number;
    /**
     * RTX DVC can be instantly enabled without game relaunch or not
     */
    instantEnableSupported?: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIDVCStateParameters".
 */
export interface GetAIDVCStateParameters {
    /**
     * cmsId of the application.
     */
    cmsId: number;
    /**
     * Process ID for the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIDVCStateReturn".
 */
export interface GetAIDVCStateReturn {
    /**
     * DeepDVC enabled on system.
     */
    enabled?: boolean;
    /**
     * Last applied vibrance value.
     */
    intensity?: number;
    /**
     * Last applied saturation value.
     */
    saturation?: number;
    /**
     * Offline DeepDVC support state.
     */
    offlineSupported?: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "SetAIDVCStateParameters".
 */
export interface SetAIDVCStateParameters {
    /**
     * cmsId of the application.
     */
    cmsId: number;
    /**
     * Process ID of the application to which apply vibrance.
     */
    processId: number;
    /**
     * Enable or disable feature per application.
     */
    enabled: boolean;
    /**
     * Vibrance value to set.
     */
    intensity: number;
    /**
     * Saturation value to set.
     */
    saturation: number;
    /**
     * Save vibrance value to DRS.
     */
    saveEnabled: boolean;
    /**
     * Save vibrance value to DRS.
     */
    saveIntensity: boolean;
    /**
     * Save vibrance value to DRS.
     */
    saveSaturation: boolean;
    /**
     * Set or reset visual effect in real time.
     */
    applyEffectInRealTime: boolean;
    /**
     * Whether Global or per App profile is used in DRS
     */
    isUseGlobal: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetRealtimeAIDVCStateParameters".
 */
export interface GetRealtimeAIDVCStateParameters {
    /**
     * processId of the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetRealtimeAIDVCStateReturn".
 */
export interface GetRealtimeAIDVCStateReturn {
    /**
     * AIDVC enabled for a game
     */
    enabled?: boolean;
    /**
     * Error code for PPE feature like AIDVC
     */
    errorCode?: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "ToggleNIS2Parameters".
 */
export interface ToggleNIS2Parameters {
    /**
     * Toggle global NIS2 state.
     */
    toggle: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNIS2StateParameters".
 */
export interface GetNIS2StateParameters {
    /**
     * cmsId of the application.
     */
    cmsId: number;
    /**
     * Process ID for the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNIS2StateReturn".
 */
export interface GetNIS2StateReturn {
    /**
     * NIS2 system support state.
     */
    supported?: boolean;
    /**
     * NIS2 enabled on system.
     */
    enabled?: boolean;
    /**
     * Last applied sharpness value.
     */
    sharpen?: number;
    /**
     * Selected resolution index.
     */
    selectedResolutionIndex?: number;
    /**
     * Array of resolution and scaling factor
     */
    resolutions?: NIS2Resolution[];
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "SetNIS2SharpenParameters".
 */
export interface SetNIS2SharpenParameters {
    /**
     * processId of the application.
     */
    processId: number;
    /**
     * Sharpness value to set.
     */
    sharpen: number;
    /**
     * Save sharpness value to DRS
     */
    saveToDRS: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRSupport_V2Return".
 */
export interface GetAIHDRSupport_V2Return {
    /**
     * TrueHDR is supported or not
     */
    globalSupport?: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRDisplayInfoForProcessParameters".
 */
export interface GetAIHDRDisplayInfoForProcessParameters {
    /**
     * processId of the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRDisplayInfoForProcessReturn".
 */
export interface GetAIHDRDisplayInfoForProcessReturn {
    /**
     * TrueHDR is supported or not
     */
    isSupported?: boolean;
    /**
     * Error code for PPE features like NIS2, DeepDVC, TrueHDR
     */
    errorCode?: number;
    /**
     * Minimum peak brightness for TrueHDR on a supported system
     */
    minPeakBrightness?: number;
    /**
     * Maximum peak brightness for TrueHDR on a supported system
     */
    maxPeakBrightness?: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRRealTimeStateParameters".
 */
export interface GetAIHDRRealTimeStateParameters {
    /**
     * processId of the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRRealTimeStateReturn".
 */
export interface GetAIHDRRealTimeStateReturn {
    /**
     * TrueHDR enabled for a game
     */
    enabled?: boolean;
    /**
     * Error code for PPE feature like TrueHDR
     */
    errorCode?: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRState_V2Parameters".
 */
export interface GetAIHDRState_V2Parameters {
    /**
     * cmsId of the application.
     */
    cmsId: number;
    /**
     * Process ID for the application.
     */
    processId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetAIHDRState_V2Return".
 */
export interface GetAIHDRState_V2Return {
    /**
     * Application allowed from DRS profile
     */
    supported?: boolean;
    /**
     * Errorcode in case application is denylisted from DRS profile
     */
    supportError?: number;
    /**
     * DeepDVC enabled on system.
     */
    enabled?: boolean;
    /**
     * Last applied peak brightness value.
     */
    peakBrightness?: number;
    /**
     * Last applied middle grey value.
     */
    middleGrey?: number;
    /**
     * Last applied contrast value.
     */
    contrast?: number;
    /**
     * Last applied saturation value.
     */
    saturation?: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "SetAIHDRState_V2Parameters".
 */
export interface SetAIHDRState_V2Parameters {
    /**
     * cmsId of the application.
     */
    cmsId: number;
    /**
     * Process ID of the application to which apply vibrance.
     */
    processId: number;
    /**
     * Enable or disable feature per application.
     */
    enabled: boolean;
    /**
     * Vibrance value to set.
     */
    peakBrightness: number;
    /**
     * Saturation value to set.
     */
    middleGrey: number;
    /**
     * Vibrance value to set.
     */
    contrast: number;
    /**
     * Saturation value to set.
     */
    saturation: number;
    /**
     * Save vibrance value to DRS.
     */
    saveEnabled: boolean;
    /**
     * Save vibrance value to DRS.
     */
    savePeakBrightness: boolean;
    /**
     * Save vibrance value to DRS.
     */
    saveMiddleGrey: boolean;
    /**
     * Save vibrance value to DRS.
     */
    saveContrast: boolean;
    /**
     * Save vibrance value to DRS.
     */
    saveSaturation: boolean;
    /**
     * Set or reset visual effect in real time.
     */
    applyEffectInRealTime: boolean;
    /**
     * Whether Global or per App profile is used in DRS
     */
    isUseGlobal: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "DlssOnGameLaunchedParameters".
 */
export interface DlssOnGameLaunchedParameters {
    /**
     * Process ID of the application.
     */
    processId: number;
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * CMS ID of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideSRStateParameters".
 */
export interface GetNGXOverrideSRStateParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideSRStateReturn".
 */
export interface GetNGXOverrideSRStateReturn {
    /**
     * NGXOverride SR enabled state.
     */
    overrideEnabled?: boolean;
    /**
     * NGXOverride SR scaling ratio
     */
    scalingRatio?: number;
    /**
     * NGXOverride SR performance mode
     */
    performanceMode?: number;
    /**
     * NGXOverride SR preset model
     */
    overrideRenderPresetSelection?: number;
    /**
     * NGXOverride SR global toggle state.
     */
    isUseGlobal?: boolean;
    /**
     * Array of general feedback
     */
    ngxFeedback?: NGXOverrideFeedback[];
    /**
     * Array of SR feature feedbacks
     */
    featureFeedback?: NGXOverrideSR_RR_Feedback[];
    /**
     * Array of SR error feedback
     */
    errFeedback?: NGXOverrideErrFeedback[];
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideRRStateParameters".
 */
export interface GetNGXOverrideRRStateParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideRRStateReturn".
 */
export interface GetNGXOverrideRRStateReturn {
    /**
     * NGXOverride RR enabled state.
     */
    overrideEnabled?: boolean;
    /**
     * NGXOverride RR scaling ratio
     */
    scalingRatio?: number;
    /**
     * NGXOverride RR performance mode
     */
    performanceMode?: number;
    /**
     * NGXOverride RR preset model
     */
    overrideRenderPresetSelection?: number;
    /**
     * NGXOverride RR global toggle state.
     */
    isUseGlobal?: boolean;
    /**
     * Array of general feedback
     */
    ngxFeedback?: NGXOverrideFeedback[];
    /**
     * Array of RR feature feedback
     */
    featureFeedback?: NGXOverrideSR_RR_Feedback[];
    /**
     * Array of RR error feedback
     */
    errFeedback?: NGXOverrideErrFeedback[];
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideFGStateParameters".
 */
export interface GetNGXOverrideFGStateParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideFGStateReturn".
 */
export interface GetNGXOverrideFGStateReturn {
    /**
     * NGXOverride FG enabled state.
     */
    overrideEnabled?: boolean;
    /**
     * NGXOverride FG multiframe count id
     */
    overrideMultiFrameCountId?: number;
    /**
     * NGXOverride FG feedback
     */
    dlssOverrideFgMultiFrameFeedback?: boolean;
    /**
     * Array of FG general feedback
     */
    ngxFeedback?: NGXOverrideFeedback[];
    /**
     * Array of FG error feedback
     */
    errFeedback?: NGXOverrideErrFeedback[];
    /**
     * NGXOverride FG global toggle state.
     */
    isUseGlobal?: boolean;
    /**
     * NGXOverride FG dynamic mode
     */
    overrideDynamicFGMode?: number;
    /**
     * NGXOverride FG dynamic target frame rate
     */
    overrideDynamicFGTargetFrameRate?: number;
    /**
     * NGXOverride FG dynamic multiplier
     */
    overrideDynamicFGMultiFrameCountMax?: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "SetNGXOverrideFGStateParameters".
 */
export interface SetNGXOverrideFGStateParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * processId of the application.
     */
    cmsId: number;
    /**
     * fgx override state
     */
    overrideEnabled: boolean;
    /**
     * frame multiplier override state
     */
    dlssOverrideFgMultiFrameFeedback: boolean;
    /**
     * frame multiplier value to set.
     */
    overrideMultiFrameCountId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetFGXStateParameters".
 */
export interface GetFGXStateParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetFGXStateReturn".
 */
export interface GetFGXStateReturn {
    /**
     * NGXOverride FGX enabled state.
     */
    isFgxEnabled?: boolean;
    /**
     * NGXOverride FGX global state
     */
    isUseGlobal?: boolean;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetFGXDynamicStateParameters".
 */
export interface GetFGXDynamicStateParameters {
    /**
     * processId of the application.
     */
    processId: number;
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetFGXDynamicStateReturn".
 */
export interface GetFGXDynamicStateReturn {
    /**
     * NGXOverride FGX enabled state.
     */
    isFgxEnabled?: boolean;
    /**
     * Array of GPU state bits on app launch
     */
    gpuState?: FgxAppLaunchedGpuState[];
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingsForNvAppParameters".
 */
export interface GetProfileSettingsForNvAppParameters {
    /**
     * Local ID of the application
     */
    localId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingsForNvAppReturn".
 */
export interface GetProfileSettingsForNvAppReturn {
    /**
     * Array of Game Profile Constraints bits for SR
     */
    constraintsSR?: NGXOverrideConstraints[];
    /**
     * Array of Game Profile Constraints bits for RR
     */
    constraintsRR?: NGXOverrideConstraints[];
    /**
     * Array of Game Profile Constraints bits for SFG
     */
    constraintsFG?: NGXOverrideConstraints[];
    /**
     * Array of Game Profile Constraints bits for SM
     */
    constraintsSM?: NGXOverrideConstraints[];
}

/**
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "DriverTypeEnum".
 */
export enum DriverTypeEnum {
    GameReadyDriver = 0,
    CreatorReadyDriver = 1
}
/**
 * constraint for hard and soft requirements
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "ConstraintType".
 */
export enum ConstraintType {
    Unknown = 0,
    GpuUnsupported = 1,
    DriverUnsupported = 2,
    HardwareSchedulingUnavailable = 3,
    GraphicsApiUnsupported = 4,
    DenyListed = 5,
    x86Unsupported = 6,
    SRModelDenyListed = 7,
    RRModelDenyListed = 8,
    FGMultiFrameCountUnsupported = 9,
    FGUIRModelDriverUnsupported = 10,
    DynamicFGDriverUnsupported = 11,
    DynamicFGSLUnsupported = 12,
    DLSSPinnedSLVersionUnsupported = 13
}
/**
 * AIHDR unsupported errors
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "AIDVCUnSupportedErrors".
 */
export enum AidvcUnSupportedErrors {
    MINIMUM_DRIVER_VERSION_NOT_MET = 20
}
/**
 * AIDVC real time errors
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "AIDVCRealTimeErrors".
 */
export enum AidvcRealTimeErrors {
    GAME_HDR_ENABLED = 0
}
/**
 * AIHDR unsupported errors
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "AIHDRUnSupportedErrors".
 */
export enum AihdrUnSupportedErrors {
    GPU_INCOMPATIBLE = 0,
    CLIENT_VIRTUALIZATION_ENABLED = 1,
    OS_INCOMPATIBLE = 2,
    MULTI_MON_DETECTED = 3,
    HDR_DISABLED = 4,
    SOC_FEATURE_ENABLED = 5,
    SLI_ENABLED = 6,
    SURROUND_ENABLED = 7,
    MSHYBRID_ENABLED = 8,
    MSHYBRID_ENABLED_DDS_IGPU = 9,
    DISPLAY_INCOMPATIBLE = 10,
    NO_DISPLAY_CONNECTED = 11,
    USE_ALTERNATE_DISPLAY = 12,
    MINIMUM_DRIVER_VERSION_NOT_MET = 20,
    GAME_DENYLISTED = 21
}
/**
 * AIHDR real time errors
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "AIHDRRealTimeErrors".
 */
export enum AihdrRealTimeErrors {
    DRS_REGKEY_NOT_SET = 0,
    UNSUPPORTED_PRESENTATION_MODE = 1,
    GAME_HDR_ENABLED = 2,
    OS_HDR_DISABLED = 3,
    SOC_FEATURES_ENABLED = 4,
    MISTMATCHED_DISPLAY = 5,
    API_NOT_SUPPORTED = 6
}
/**
 * DLSS Performance Mode Overrides
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "DlssPerformanceModeOverrideEnum".
 */
export enum DlssPerformanceModeOverrideEnum {
    Default = 3,
    Performance = 0,
    Balanced = 1,
    Quality = 2,
    UltraPerformance = 5,
    Dlaa = 4,
    Custom = 6
}
/**
 * DLSS Model Overrides
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "DlssModelOverrideEnum".
 */
export enum DlssModelOverrideEnum {
    Default = 0,
    PresetA = 1,
    PresetB = 2,
    PresetC = 3,
    PresetD = 4,
    PresetE = 5,
    PresetF = 6,
    PresetJ = 10,
    Latest = 16777215
}
/**
 * DLSS Features Overrides
 *
 * This interface was referenced by `GraphicsSettingPlugin`'s JSON-Schema
 * via the `definition` "DlssFeatures".
 */
export enum DlssFeatures {
    DLSSSR = 65542,
    DLSSRR = 65543,
    DLSSFG = 65544,
    DLSSSM = 65545
}


}
